export default __webpack_public_path__ + "static/media/model_P_curve.0b6a3d9f.png";